// extracted by mini-css-extract-plugin
export default {"headerWrapper":"styles_headerWrapper__-DAo4","linkWrapper":"styles_linkWrapper__vBFYS","title":"styles_title__rwhe8","icon":"styles_icon__Zvl43"};